export const apisUrlsData = {
    accounts: {
        categories: "/accounts/category-types",
        create: "/accounts/create",
        dataSources: "/data-sources",
        delete: "/accounts/delete/",
        edit: "/accounts/update/",
        list: "/accounts",
        selections: "/accounts/selections",
        status: "/accounts/status",
        treeList: "/accounts/tree",
    },
    auth: {
        currentUserPassword: "/users/password",
        forgetPassword: "/auth/forgot-password",
        login: "/auth/login",
        logout: "/auth/logout",
        refreshToken: "/auth/refresh",
        resetPassword: "/auth/reset-password",
        setPasswordByInvitation: "/auth/set-password-by-invitation",
        users: "/users",
        validateInvitationToken: "/auth/validate-invitation-token",
        validateResetPasswordToken: "/auth/validate-reset-password-token",
    },
    dataSources: {
        amount: "/amount",
        auditLogs: "/audit/datasources/",
        calculate: "/calculate",
        categories: "/datasources/categories",
        channel: { plaid: "/plaid/link-token" },
        clone: "/clone",
        creditDebitValues: "/credit-debit-values",
        dateTimeZones: "/date-time-zones",
        detailsOverview: "/overview",
        entry: "/entry",
        fileUrl: "/file-url",
        integrations: "/integrations",
        list: "/datasources",
        matched: "/matched",
        offline: "/datasources/offline",
        offlineMapping: "/datasources/offline/mapping",
        online: "/datasources/online",
        options: "/options",
        overview: "/datasources/overview",
        rrnTypes: "/rrn-types",
        subCategories: "/subcategories",
        summary: "/summary",
        sync: "/datasources/sync/",
        transform: {
            amount: "/transformations/amount",
            dateTime: "/transformations/date-time",
            name: "/transformations/name",
            status: "/transformations/status",
        },
        types: "/datasources/types",
    },
    ledgers: {
        entries: "/entries",
        entriesCounts: "/entries/counts",
        list: "ledgers/transactions",
        overview: "/ledgers/overview",
        transactionEntries: "ledgers/transactions/entries/",
    },
    organizations: {
        apiKeys: "/organizations/api-keys",
        currencies: "/organizations/currencies",
        dataSourcesOverview: "/datasources-overview",
        entries: "/usage/entries-meters",
        jobsOverview: "/jobs-overview",
        list: "/organizations",
        operationRegions: "/organizations/operation-regions",
        options: "/organizations/options",
        revoke: "/revoke",
        selections: "/organizations/selections",
        usageSummary: "/usage/summary",
        users: "/users",
    },
    reconciliations: {
        confidenceInsights: "/insights/confidence",
        executionPlan: "/execution-plan",
        export: "/export",
        insights: "/insights",
        lastMatchingAuditJob: "/matching-audit/jobs/last",
        list: "/reconciliations",
        logsList: "/matching-audit/jobs",
        manual: "/manual",
        matchingAudit: "/matching-audit",
        overview: "/overview",
        results: "/reconciliations/results",
        ruleInsights: "/insights/rule",
        ruleOptions: "/rules-options",
        run: "/run",
        transactions: "/transactions",
        unmatch: "/reconciliations/unmatch",
    },
    transactions: {
        account: "/transactions/account/",
        auditActions: "/audit/transaction-actions",
        auditLogs: "/audit/transactions/",
        dataSource: "/transactions/datasource/",
        list: "/transactions",
        matched: "/matched",
        matchingAudit: "/matching-audit",
        metadata: "/metadata",
        related: "/related",
        revertVersion: "/audit/transactions/versions/",
        status: "/transactions-status",
        unmatched: "/unmatched",
        uploadFile: "/transactions/upload/",
        versionDetails: "/audit/transactions/versions/",
        versionLogs: "/audit/transactions/",
        versions: "/versions/",
    },
    users: {
        invite: "admin/users/invite",
        list: "admin/users",
        password: "/password",
    },
};
